import { render, staticRenderFns } from "./PreSelectProducerCampaign.vue?vue&type=template&id=68de9c88&"
import script from "./PreSelectProducerCampaign.vue?vue&type=script&lang=js&"
export * from "./PreSelectProducerCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports